import React from "react"
import facebook from "../../assets/SVG/facebook.svg"
import twitter from "../../assets/SVG/twitter.svg"
import mail from "../../assets/SVG/mail.svg"
import youtube from "../../assets/SVG/youtube.svg"

const Footer = props => {
  return (
    <footer className="Footer">
      <div className="Footer-contact">
        <div>
          <h3>Adrienne Boris</h3>
        </div>
        <div>
          <small>Stage Director | Producer | Acting Coach</small>
        </div>
        <div>
          <small>created by The Curtis Project</small>
        </div>
      </div>
      <div className="Footer-socialMedia">
        <a
          href="https://www.youtube.com/channel/UCY2VV4ekUvuhX2pfw4EO2-g"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg className="Footer-YT Footer-icon">
            <use xlinkHref={`#${youtube.id}`} />
          </svg>
        </a>
        <a
          href="mailto:adrienne.boris@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg className="Footer-mail Footer-icon">
            <use xlinkHref={`#${mail.id}`} />
          </svg>
        </a>
        <a
          href="https://twitter.com/adrienneboris84"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg className="Footer-twitter Footer-icon">
            <use xlinkHref={`#${twitter.id}`} />
          </svg>
        </a>
        <a
          href="https://www.facebook.com/BorisDirects"
          target="_blank"
          rel="noopener noreferrer"
        >
          <svg className="Footer-facebook Footer-icon">
            <use xlinkHref={`#${facebook.id}`} />
          </svg>
        </a>
      </div>
    </footer>
  )
}

export default Footer
